export { default } from './PageInfoPage.vue'
